import { useMemo } from 'react';
import { SelectValue } from '../../../Components/Base/Select/Select';
import useTranslation from '../../../Hooks/useTranslation';

export default function useSelectOptions(
	options: SelectValue[],
	translate: boolean = true,
) {
	const { t } = useTranslation();

	const translatedOptions: SelectValue[] = useMemo(() => {
		if (!translate) {
			return options;
		}
		return options.map(({ label, ...rest }) => ({
			...rest,
			label: t(label),
		}));
	}, [options]);

	return {
		translatedOptions,
	};
}
